export const No = ({ className }) => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className },
    React.createElement("path", { d: "M6.002 6 18.34 18.34M18.339 6 6 18.338", stroke: "#9BA1A9", "stroke-width": "3", "stroke-linecap": "round" })));

